import { BOOKING_URL, scrollToId } from "../data/content";

const LINKS = [
    ["About IHCC", "#about"],
    ["Why Visit", "#why-visit"],
    ["Collections", "#collections"],
    ["Visitor Experience", "#experience"],
    ["George Town", "#george-town"],
    ["Visit Us", "#visit"],
    ["FAQ", "#faq"],
];

const Footer = () => (
    <footer
        data-testid="site-footer"
        className="border-t border-heritage-gold/15 bg-heritage-ink"
    >
        <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 md:grid-cols-3 md:px-10">
            <div>
                <div className="flex items-center gap-4">
                    <img
                        src="/images/ihcc-logo.png"
                        alt="Indian Heritage Cultural Centre Penang logo — vintage heritage lantern mark"
                        className="h-14 w-auto"
                        loading="lazy"
                    />
                    <div>
                        <p className="font-serif text-lg font-semibold text-heritage-parchment">
                            Indian Heritage Gallery and Cultural Centre (IHCC)
                        </p>
                        <p className="font-mono text-[9px] uppercase tracking-[0.3em] text-heritage-gold">
                            Heritage Museum &amp; Cultural Attraction · Georgetown, Penang
                        </p>
                    </div>
                </div>
                <p className="mt-6 max-w-xs text-sm leading-relaxed text-heritage-parchment/55">
                    The Indian Heritage Cultural Centre preserves, presents and celebrates Indian
                    heritage in the heart of George Town's UNESCO heritage zone.
                </p>
            </div>

            <nav aria-label="Footer">
                <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-heritage-gold">
                    Explore
                </p>
                <ul className="mt-5 space-y-3">
                    {LINKS.map(([label, hash]) => (
                        <li key={hash}>
                            <a
                                href={hash}
                                onClick={(e) => {
                                    e.preventDefault();
                                    scrollToId(hash);
                                }}
                                className="text-sm text-heritage-parchment/60 transition-colors hover:text-heritage-gold"
                            >
                                {label}
                            </a>
                        </li>
                    ))}
                </ul>
            </nav>

            <div>
                <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-heritage-gold">
                    Visit
                </p>
                <address className="mt-5 space-y-2 text-sm not-italic leading-relaxed text-heritage-parchment/60">
                    <p>57 Lebuh Pantai, George Town, Penang, Malaysia</p>
                    <p>Open daily · 10:00 AM – 7:00 PM</p>
                    <p>
                        <a href="tel:+6042260264" className="transition-colors hover:text-heritage-gold">
                            +604 226 0264
                        </a>
                    </p>
                    <p>
                        <a
                            href="mailto:galleryihcc@gmail.com"
                            className="transition-colors hover:text-heritage-gold"
                        >
                            galleryihcc@gmail.com
                        </a>
                    </p>
                </address>
            </div>
        </div>

        <div className="border-t border-white/10">
            <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3 px-5 py-6 font-mono text-[10px] uppercase tracking-[0.2em] text-heritage-parchment/40 md:px-10">
                <p>© 2026 Indian Heritage Cultural Centre · George Town, Penang</p>
                <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
                    <a
                        href="https://staymii.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-staymii-etickets-link"
                        className="transition-colors hover:text-heritage-gold"
                    >
                        E-tickets by StayMii
                    </a>
                    <a
                        href={BOOKING_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="transition-colors hover:text-heritage-gold"
                    >
                        Tickets · indianheritagegalleryandculturalcentre.com
                    </a>
                    <a
                        href="https://staymii.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-staymii-credit-link"
                        className="transition-colors hover:text-heritage-gold"
                    >
                        Website made by StayMii.com
                    </a>
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;
